import { Injectable } from '@angular/core';
import { EvcApiService } from '@app/shared/modules/evc-api/services/evc-api.service';
import { Observable } from 'rxjs';
import { LanguageService } from 'src/app/core/language/services/language.service';
import { AnalyticsHelperService } from 'src/app/modules/evc-small-biz/services/analytics-helper.service';
import { SmallBizStoreService } from 'src/app/modules/evc-small-biz/stores/small-biz-store.service';
import { ChargingCardOutboundFormMapper } from './form.mapper';
import { ChargingCardOutboundFormModel } from './form.model';

@Injectable()
export class ChargingCardOutboundFormService {
  constructor(
    private mapper: ChargingCardOutboundFormMapper,
    private languageService: LanguageService,
    private store: SmallBizStoreService,
    private evcApiService: EvcApiService,
    private analyticsHelperService: AnalyticsHelperService,
  ) {}

  public getModel(): ChargingCardOutboundFormModel {
    return this.mapper.map();
  }

  public post(model: ChargingCardOutboundFormModel): Observable<any> {
    const contact = this.mapper.payload(model, this.languageService.getLanguage(), this.store.model);
    return this.evcApiService.createContactChargingCard(contact);
  }

  public analyticsSuccess(): void {
    this.analyticsHelperService.analyticsWorkflowStep('charging-card-outbound-contact-request-submit', {
      event: 'b-to-b-ev-simulator-charging-card-outbound-contact-request-submit',
      maxCards: true
    });
  }
}
